var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{class:{
    'active-filter': _vm.isUsed,
  },attrs:{"name":_vm.name,"value":_vm.value,"label":_vm.label,"append-icon":"mdi-close","outlined":"","hide-details":"","dense":"","autocomplete":"off"},on:{"input":function($event){return _vm.filterChanged($event)},"click:append":_vm.reset}})}
var staticRenderFns = []

export { render, staticRenderFns }